export default __webpack_public_path__ + "static/media/light_1_placeholder.9c9462e8.jpg";